import React from 'react';
import PropTypes from 'prop-types';

import MartyLink from 'components/common/MartyLink';
import css from 'styles/components/account/rewardsOptIn.scss';

const RewardsOptIn = ({ onSignUp }) => (
  <div>
    <div className={css.terms}>
      <h2>Join Zappos Rewards</h2>
      <p>
          Join Zappos Rewards to earn points, cool swag, and supercharged service unlike<br/>
          anything you've ever experienced. Zappos Rewards is free to join!<br/>
          It's our way of thanking you for being such a loyal customer.
      </p>
      <form method="post" onSubmit={onSignUp}>
        <div className={css.termsCheckbox}>
          <input type="checkbox" id="rewardsTerms" required/>
          <label htmlFor="rewardsTerms">I have read and agree to the Zappos Rewards Program Terms &amp; Conditions</label>
        </div>
        <MartyLink to="/rewards-terms-of-use">Read The Terms &amp; Conditions</MartyLink>
        <div className={css.signUpButton}>
          <button type="submit">Sign Up!</button>
        </div>
        <div className={css.learnMoreButton}>
          <MartyLink to="/zappos-rewards/">Learn More About Rewards</MartyLink>
        </div>
        <MartyLink
          to="/c/rewards-faq"
          data-track-action="Action"
          data-track-label="Loyalty"
          data-track-value="GotoQuestions">
            Have Questions? Read The FAQs.
        </MartyLink>
      </form>
    </div>
  </div>
);

RewardsOptIn.contextTypes = {
  testId: PropTypes.func
};

RewardsOptIn.propTypes = {
  onSignUp: PropTypes.func.isRequired
};

export default RewardsOptIn;
